export const beamProjectileIconSvg = `
<svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 0L10 20H0L5 0Z" fill="#00FFFF"/>
</svg>
`;
